'use client';

// Opens the Usercentrics consent preferences ("second layer"). Name kept as
// `reloadOTBanner` to preserve the shared UI LeftSidebar prop contract.
export const reloadOTBanner = () => {
  window.__ucCmp?.showSecondLayer?.();
};
